<template>
  <nuttrema-layout-form-standard :edit="edit" :theme="theme">
    <template slot="center">

      <el-form
        :model="formData"
        :rules="rules"
        ref="subscirption-upgrade"
        label-width="16em">

          <section>
            <h4 class="section-title">{{ $t('label.payment_information') }}</h4>
            <div class="section-items">
              <el-form-item :label="$t('label.cardholder_name')" prop="cardholder_name">
                <el-col :span="16">
                  <el-input v-model="formData.cardholder_name" :disabled="!edit"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item :label="$t('label.email')" prop="email">
                <el-col :span="16">
                  <el-input v-model="formData.email" :disabled="!edit"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item :label="$t('label.card')" prop="card">
                <el-col :span="16">
                  <!-- @change="stripe.complete = $event.complete" -->
                  <card
                     class="stripe-card"
                    :class="{ 'complete': stripe.complete, 'is-active': stripe.focus, 'is-disabled': !edit }"
                    :stripe="stripe.key"
                    :options="stripe.options"
                    @change="creditCardChanged"
                    @focus="stripe.focus = true"
                    @blur="stripe.focus = false">
                  </card>
                </el-col>
              </el-form-item>
              <el-form-item :label="$t('label.billing_address')" prop="address">
                <el-row>
                  <el-col :span="18">
                    <el-input v-model="formData.address" :placeholder="$t('label.street')" :disabled="!edit"></el-input>
                  </el-col>
                  <el-col :span="5" :offset="1">
                    <el-input v-model="formData.house_no" :placeholder="$t('label.house_no')" :disabled="!edit"></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="9">
                    <el-input v-model="formData.city" :placeholder="$t('label.city')" :disabled="!edit"></el-input>
                  </el-col>
                  <el-col :span="4" :offset="1">
                    <el-input v-model="formData.zip" :placeholder="$t('label.zip')" :disabled="!edit"></el-input>
                  </el-col>
                  <el-col :span="9" :offset="1">
                    <el-input v-model="formData.country" :placeholder="$t('label.country')" :disabled="!edit"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </div>
          </section>

          <section>
            <div class="section-title">{{ $t('label.subscription_summary') }}</div>
          </section>

      </el-form>

    </template>

    <template slot="footer">
      <nav class="level">
        <div class="level-left">
          <el-button
            type="text"
            @click="cancelChanges">
            <i class="el-icon-arrow-left"></i> {{ $t('label.upgrade_plan') }}
          </el-button>
        </div>
        <div class="level-center w-60">
          <el-button
             type="nuttrema-dark-gray"
             class="w-100"
            :disabled="!stripe.complete"
            @click="pay">
            Confrim upgrade and proceed with payment
          </el-button>
        </div>
        <div class="level-right">
          <el-button
            type="text"
            @click="cancelChanges">
            {{ $t('label.cancel_upgrade') }}
          </el-button>
        </div>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { assign, get } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';

import { Card, createToken } from 'vue-stripe-elements-plus';

export default {
  name: 'form-settings-subscription',
  props: {
    InstanceDetails: {
      type: Object,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    Card,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      stripe: {
        focus: false,
        complete: false,
        key: process.env.STRIPE_KEY,
        options: {
          hidePostalCode: true,
          style: {
            base: {
              fontSize: '14px',
              lineHeight: '24px',
            },
          },
        },
      },
      formData: {
        cardholder_name: null,
        card: null,
        email: null,
        address: null,
        city: null,
        house_no: null,
        zip: null,
        country: null,
      },
      originalData: {},
      rules: {
        cardholder_name: [
          { required: true, message: 'Please input name', trigger: 'blur' },
        ],
        email: [
          { required: true, message: 'Please input name', trigger: 'blur' },
        ],
        card: [
          { required: true, message: 'Please input name', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const payload = this.getData();
          this.$emit('submit', this.toJSON(payload));
        }
        return valid;
      });
    },
    cancelChanges() {
      // this.edit = false;
      // this.formData = assign({}, this.originalData);
      // this.$nextTick(() => {
      //   this.$refs[formName].validate();
      // });
      this.$emit('update:edit', false);
    },
    creditCardChanged(evt) {
      console.log(evt);
      this.stripe.complete = evt.complete;
      this.formData.card = evt.complete ? 'card-added' : null;
    },
    toJSON(data) {
      return JSON.parse(JSON.stringify(data));
    },
    mapData() {},
    getData() {},
    pay() {
      createToken().then(data => console.log(data.token));
    },
  },
  created() {
    assign(this.formData, {
      cardholder_name: get(this.InstanceDetails, 'data.Owner.full_name', null),
      email: get(this.InstanceDetails, 'data.Owner.email', null),
      city: get(this.InstanceDetails, 'data.Owner.city', null),
    });
  },
};
</script>

<style lang="scss" scoped>
  .stripe-card {
    width: 100%;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #d8dce5;
    padding: 7px 2px 7px 15px;
    &.is-active {
      border-color: #409EFF;
    }
    &.is-disabled {
      pointer-events: none;
      background-color: #F7F7F7;
      border: 1px solid #F7F7F7;
      /deep/ .StripeElement {
        visibility: hidden;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/instance/subscription/form-settings-checkout.vue